/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {applyRewardCode} from '../api'

export const useMutationApplyRewardCode = createReactQueryMutationHook('applyRewardCode', applyRewardCode)
